export default __webpack_public_path__ + "caa1cbe53b57acde1fef0eae47b04981.gif";